import rocket from "./Rocket"

export class CreateRocket {
  constructor(boardContainer) {
    this.rocket = rocket
    this.boardContainer = boardContainer
  }
  rocket = () => this.rocket
  rocketBackToStartingPosition = () => {
    this.boardContainer.addChild(this.rocket)
    this.rocket.position.set(158, 235)
    this.rocket.rotation = 0
  }
}
